import { styled } from '@mui/material/styles';

type ModelAvatarProps = {
  size: number;
  color: string;
};

export const ModelAvatar = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'color',
})<ModelAvatarProps>(({ size, color }) => ({
  position: 'relative',
  borderRadius: '50%',
  backgroundColor: color,
  height: size + 8,
  width: size + 8,
  minHeight: size + 8,
  minWidth: size + 8,
}));

export const CombinedIcon = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));
